<template>
    <div class="filter-section">
        <h5>{{ title }}</h5>
        <md-field>
            <md-select v-model="selectedValue" :name="id" :id="id">
                <md-option value="All">All</md-option>
                <md-option v-for="option in options" :key="option.id" :value="option.id">
                    {{ option.label }}
                </md-option>
            </md-select>
        </md-field>
    </div>
</template>

<script>
export default {
    name: 'SelectFilter',
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default() {
                return this.title;
            }
        },
        value: {
            type: String,
            default: 'All'
        },
        options: {
            type: Array,
            required: true
        },
        currentFilterValue: {
            type: [Number, String],
            default: () => 'All'
        }
    },
    data() {
        return {
            selectedValue: this.value
        };
    },
    watch: {
        selectedValue() {
            this.emitChange();
        }
    },
    methods: {
        emitChange() {
            this.$emit('change', {
                id: this.id,
                value: this.selectedValue,
                component: 'SelectFilter'
            });
        },
        reset() {
            this.selectedValue = this.currentFilterValue;
            this.emitChange();
        }
    }
};
</script>

<style scoped>
.filter-section {
    margin-bottom: 0px;
}

.filter-section h5 {
    margin-top: 0;
    margin-bottom: 0px;
    font-weight: 500;
}
</style>
